import { Tab } from "@mui/material";
import React from "react";
import ChartTabs from "../../Common/ChartTabs";
import YearOverYear from "./Charts/Trends/YearOverYear";
import MonthlyDrops from "./Charts/Trends/MonthlyDrops";
import DiversityDrop from "./Charts/Trends/DiversityDrop";
import PriceMode from "./Charts/Trends/PriceMode";
import QuarterlyDrops from "./Charts/Trends/QuarterlyDrops";
import ProductDrops from "./Charts/Trends/ProductDrops";

export default function Trends({ height }: { height: number }){
    const [yearoveryear, setYearOverYear] = React.useState([]);
    
    React.useEffect(() => {
        fetch(`/dashboard/year-over-year/?entity_id=${localStorage.getItem('entity_id')}`)
            .then(response => response.json())
            .then(data => setYearOverYear(data.yearoveryear));
    }, []);

    return (
        <ChartTabs 
            tabs={[
                <Tab wrapped style={{ textTransform: 'capitalize' }} label="Yearly over Year" value="0" />,
                <Tab wrapped style={{ textTransform: 'capitalize' }} label="Monthly Drops" value="1" />,
                <Tab wrapped style={{ textTransform: 'capitalize' }} label="Quarterly Drops" value="2" />,
                <Tab wrapped style={{ textTransform: 'capitalize' }} label="Diversity Drops" value="3" />,
                <Tab wrapped style={{ textTransform: 'capitalize' }} label="Product Drops" value="4" />,
                <Tab wrapped style={{ textTransform: 'capitalize' }} label="Price Mode" value="5" />,
            ]} 
            values={["0", "1", "2", "3", "4", "5"]} 
            ariaLabel="revenue tabs"
            panels={[
                <YearOverYear data={yearoveryear} title="Current 12 month sales vs Previous 12 month sales" height={height} />,
                <MonthlyDrops title="Monthly Drops" height={height} />,
                <QuarterlyDrops title="Quarterly Drops" height={height} />,
                <DiversityDrop title="Diversity Drops" height={height} />,
                <ProductDrops title="Product Drops" height={height} />,
                <PriceMode title="Gross Profit" height={height} />
            ]}
        >
        </ChartTabs>
    )
}